/// <summary>
/// JSON的包装类
/// </summary>
/// <author>xiexingwu</author>
import {JObject} from "@/Fwk/Kit/JObject";

export class JsonData {
    jObject: JObject;

    public constructor(jb: JObject | null = null, jsonStr: string | null = null) {
        if (jb) {
            this.jObject = jb;
        } else if (jsonStr) {
            this.jObject = JSON.parse(jsonStr);
        } else {
            this.jObject = {};
        }
    }

    public get Count(): number {
        return Object.keys(this.jObject).length;
    }

    public putJsonDataArray(key: string, v: JsonData[]) {
        const array: JObject[] = [];
        for (let data of v) {
            array.push(data.jObject)
        }
        this.jObject[key] = array;
    }

    put(key: string, v: number | boolean | string | JObject | JsonData | null) {
        if (!v) {
            delete this.jObject[key]
        } else if (v instanceof JsonData) {
            this.jObject[key] = v.jObject;
        } else {
            this.jObject[key] = v;
        }
    }

    public Remove(key: string) {
        delete this.jObject[key]
    }

    public OptInt(key: string, def = 0): number {
        const v = this.jObject[key];
        if (typeof v === 'number') {
            return v;
        } else if (typeof v === 'string') {
            const num = parseInt(v);
            if (!isNaN(num)) {
                return num;
            }
        }
        return def;
    }

    public OptFloat(key: string, def = 0): number {
        const v = this.jObject[key];
        if (typeof v === 'number') {
            return v;
        } else if (typeof v === 'string') {
            const num = parseFloat(v);
            if (!isNaN(num)) {
                return num;
            }
        }
        return def;
    }

    public OptLong(key: string, def = 0): number {
        return this.OptInt(key, def);
    }

    public OptString(key: string, def = ""): string {
        const v = this.jObject[key];
        if (typeof v === 'number') {
            return "" + v;
        } else if (typeof v === 'string') {
            return v;
        }
        return def;
    }

    public OptBoolean(key: string, def = false): boolean {
        const v = this.jObject[key];
        if (typeof v === 'boolean') {
            return v;
        } else if (typeof v === 'number') {
            return v == 1;
        } else if (typeof v === 'string') {
            return v === "1";
        }
        return def;
    }

    public OptJOb(key: string): JObject | null {
        return this.jObject[key];
    }

    public OptJsonData(key: string): JsonData | null {
        return new JsonData(this.jObject[key]);
    }

    public OptJsonDataArray(key: string): JsonData[] | null {
        const array = this.jObject[key];
        if (!array) return null;
        let back: JsonData[] = []
        for (let item of array) {
            back.push(new JsonData(item));
        }
        return back;
    }


    public ReadAllStringKVs(): Map<string, string> {
        let values: Map<string, string> = new Map();
        const keys = Object.keys(this.jObject);
        for (const key of keys) {
            if (typeof this.jObject[key] === 'string') {
                values.set(key, this.jObject[key]);
            }
        }
        return values;
    }

    public toString(): string {
        return JSON.stringify(this.jObject);
    }
}